import Vue from 'vue';
import OrderStatuses from '@/plugins/graphql/queries/v2/order-statuses.gql';
import { OrderStatusModel } from '@/helpers/entities/models/OrderStatusModel';
export default Vue.extend({
    apollo: {
        orders: {
            query: OrderStatuses,
            variables() {
                return {
                    appUuid: this.appUuid,
                };
            },
            update(data) {
                const orders = data.orderStatuses.edges;
                const orderNodes = (order) => {
                    return new OrderStatusModel(order.node);
                };
                return orders.map(orderNodes);
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            orders: [],
        };
    },
    computed: {
        dataForCsv() {
            const self = this;
            if (self.orders.length >= 1) {
                return self.orders.map((orderStatus) => {
                    return {
                        transactionNumber: orderStatus.order.transactionNumber,
                        productName: orderStatus.order.firstItem.productName,
                        customerName: `${orderStatus.order.firstName} ${orderStatus.order.lastName}`,
                        amount: orderStatus.order.grandTotal,
                        paymentMethod: orderStatus.order.paymentOption.paymentName,
                        orderDate: orderStatus.formattedPlacedAt,
                    };
                });
            }
            return [];
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            const self = this;
            return this.$scopedSlots.default({
                orders: self.dataForCsv,
            });
        }
    },
});
